/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';


export const SvgEditProfile = ({ size }) => {
    return (<Svg
        viewBox="0 0 147.43 148.21"
        height={size}
        width={size}
    >
        <G id="Layer_2" data-name="Layer 2">
            <G id="Layer_1-2" data-name="Layer 1">
                <Path fill="#6cc" class="cls-1" d="M113.43,77.23a34,34,0,1,0,34,34A34,34,0,0,0,113.43,77.23Zm0,63.37a29.37,29.37,0,1,1,29.37-29.37A29.37,29.37,0,0,1,113.43,140.6Z" />
                <Path fill="#49536b" class="cls-2" d="M76.31,111.23A37,37,0,0,1,89.85,82.56C83.72,72.14,75.19,64.19,65.32,60.1a32,32,0,1,0-30.64,0C14.56,68.45,0,92.77,0,121.5c0,28.23,62.81,34.08,88.87,17.56A37,37,0,0,1,76.31,111.23Z" />
                <Path fill="#6cc" class="cls-1" d="M125.87,96.54a2,2,0,0,0-2.82-.15l-3,2.67,6.46,7.19,3-2.67a2,2,0,0,0,.15-2.82Z" />
                <Polygon fill="#6cc" class="cls-1" points="96.69 126.59 97.75 126.37 97.03 125.56 96.69 126.59" />
                <Polygon fill="#6cc" class="cls-1" points="99.75 117.34 99.69 117.39 99.69 117.38 97.14 125.21 98.11 126.29 106.16 124.59 106.16 124.58 106.22 124.53 99.75 117.34" />
                <Rect fill="#6cc" class="cls-1" x="100.78" y="106.98" width="24.72" height="9.67" transform="translate(-45.75 104.31) rotate(-41.96)" />
            </G>
        </G>

    </Svg>)
}

